import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Legacy /login route now opens the WhatsApp OTP modal and redirects home.
const Login = () => {
  const { openLogin } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    openLogin("/my-orders");
    navigate("/", { replace: true });
  }, [openLogin, navigate]);
  return null;
};

export default Login;
